<template>
  <div class="menu">
    <div class="title">
      <img alt="logo" src="../../assets/qxintech.png" v-if="$isCurrentLang('zh')">
      <img alt="logo" src="../../assets/enqxintech.jpg" v-if="$isCurrentLang('en')">
    </div>
    <div class="menu-main">
      <el-menu active-text-color="#ffd04b"
               background-color="#545c64"
               class="el-menu-vertical-demo"
               default-active="2"
               :default-openeds="['0']"
               text-color="#fff">
        <template v-for="(item,i) in menu">
          <el-submenu :index="`${i}`" :key="i" v-if="item.hasGroup!==false" v-url-check="item.permission">
            <template slot="title">
              <div class="first_level_menu">
                <i :class="item.icon"></i>
                <div class="first_level_menu_title">{{item.title}}</div>
              </div>
            </template>
            <el-menu-item-group>
              <el-menu-item :index="i+'-'+j"
                            :key="v.title"
                            @click="addTab(v)"
                            @mouseenter.native="hoverTab(v,true)"
                            @mouseleave.native="hoverTab(v,false)"
                            v-url-check="v.permission"
                            v-for="(v,j) in item.value">
                <span class="menu-title">{{v.title}}</span>
              </el-menu-item>
            </el-menu-item-group>
          </el-submenu>
          <el-menu-item :key="i"
                        @click="addTab(item)"
                        @mouseenter.native="hoverTab(item,true)"
                        @mouseleave.native="hoverTab(item,false)"
                        v-url-check="item.permission"
                        v-else>
            <i :class="item.icon"></i>
            <span>{{item.title}}</span>
          </el-menu-item>
        </template>
      </el-menu>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Menu',
    data() {
      return { menu: [] };
    },
    async created() {
      this.menu = JSON.parse(JSON.stringify(this.$store.state.tab.menu));
      const data = JSON.parse(localStorage.getItem('menuList'));
      if (data) {
        const sysMenuList = data.filter(e => e.sysName === '运营后台');
        const menuObj = {};
        sysMenuList.forEach(e => {
          if (e.pid === 0 && e.checked) {
            menuObj[e.id] = {
              ...e,
              children: []
            };
          }
        });
        sysMenuList.forEach(e => {
          if (e.pid !== 0) {
            if (menuObj[e.pid]) {
              if (e.checked) {
                menuObj[e.pid].children.push(e.name);
              }
            }
          }
        });
        this.menu.forEach(e => {
          Object.values(menuObj).forEach(item => {
            if (item.name === e.key) {
              e.show = true;
              e.value.forEach(m => {
                if (item.children && item.children.indexOf(m.title) > -1) {
                  m.show = true;
                }
              });
            }
          });
        });
      }
      this.menu = this.menu.filter(e => e.show === true);
      this.menu.forEach(item => {
        item.value = item.value.filter(e => e.show === true);
      });
      console.log(this.menu);
    },
    methods: {
      addTab(value) {
        this.$router.push(`/${value.component}`);
      },
      hoverTab(v, isShow) {
        v.add = isShow;
      },
      goIndex() {
        window.open('/basecommonweb/', '_self');
      }
    }
  };
</script>

<style lang="scss" scoped>
</style>
